import React, {Component} from 'react';
import {NavBar, SearchBar, Toast} from 'antd-mobile';
import BMap from "BMap";
import {connect} from "react-redux";
import "./style.less";
import {checkDistance} from '../../../../../service/shuntService'
import {translate} from '../../../../../service/homeService';
const mapImg = require('../../../../../common/image/position.png');
let map,point,geolocation,gc,poi,ls;
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class SelectAddress extends Component {
    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
            errorTips: [
                '',
                '您当前所在位置超出接送范围！',
                '超出接送范围，请重新选择！',
                '无法精确定位到当前位置，请重新选择！',
            ],
            curTips: '',
            isError: false,
            address:'',
            searchValue:'',
            poiList:[],
            poiListFlag:false,
            modalType:'',
            citySearch:'',
            haveChangeAddress:false,//是否拖拽过地图，默认未拖拽过
            addressCanBeUse:false,//地址是否可用 more不可用
            endPoint:'',
            endCity:'',
        };
    }
    componentDidMount() {
        //需要在这里根据上个页面传递过来的起止点设置为地图中心点。并将初始的上下车地址设置为起止点地址。
        const self = this;
        map = new BMap.Map('mapContainer');
        gc = new BMap.Geocoder();
        if(this.props.location.startPoint){
            point = this.props.location.startPoint.split("_"); 
            // map.centerAndZoom(new BMap.Point(parseFloat(point[1]),parseFloat(point[0])), 15);
            this.convertjwd(point[0],point[1],5,(r)=>{
                map.centerAndZoom(new BMap.Point(r.split('_')[1],r.split('_')[0]), 15);
            })
        }
        ls = new BMap.LocalSearch(map, {
            onSearchComplete: (res) => {
                let s = [];
                if (res) {
                    for (var i = 0; i < res.getCurrentNumPois(); i++) {
                        s.push(res.getPoi(i))
                    }
                    self.setState({
                        poiList: s,
                    });
                }
            },
        });
        map.addEventListener('dragend', function (e) {
                let centerPoint = map.getCenter();
                gc.getLocation(centerPoint, function (res) {
                    if (res.surroundingPois.length) {
                        let firstPoint = res.surroundingPois[0];
                        self.setData(self, firstPoint.title, firstPoint.point.lng, firstPoint.point.lat, false, 0,true,true);
                    } else {
                        self.setData(self, '', '', '', true, 3,true,false);
                    }
                });
        });

    }
    convertjwd(lat,lng,type,callback){
        let params = {
            token:this.props.userInfo.token,
            data:{
                position:lat+'_'+lng,
                type:type,
            }
        }
        translate(params).then((res) => {
            if (res.data.code === '0000') {
                return callback(res.data.data)
            }else if (res.data.code === '1401') {
                document.location = `js://toLogin?token=${this.props.userInfo.token}`;
            }else {
                Toast.info(res.data.msg);
            }
        })
    }
    selPoi(res){
        let props = this.props.location.datas;
        if(props.type == 'start'){
            map.setCenter(res.point);
            this.setData(this, res.title, res.point.lng, res.point.lat, false, 0,false,false);
            this.setState({poiListFlag:false,searchValue:'',poiList: []});
        }else{
            map.setCenter(res.point);
            this.setData(this, res.title, res.point.lng, res.point.lat, false, 0,false,false);
            this.setState({poiListFlag:false,searchValue:'',poiList: []});
        }
        // console.log(res)
    }
    searchChange=(value)=>{
        this.setState({ searchValue:value ,poiListFlag:true});
        this.tabDOM.scrollTop = 0;
        ls.search(value);
    };
    onClear=()=>{
        this.setState({poiList: [],poiListFlag:false,searchValue:'',siteCityFlag:false});
    };


    onClose = () => {
        this.setState({
            citySearch: '',
        });
    };

    /**
     * evented 是否拖拽过
     * canbeUsed 地址是否可用
     */
    setData = (self, title, lng, lat, boolean, index,evented,canbeUsed) => {
        self.setState({
            address: title,
            isError: boolean,
            curTips: self.state.errorTips[index],
            addressCanBeUse:canbeUsed,
            haveChangeAddress:evented
        });
        poi = {
            lng: lng,
            lat: lat,
            address: title,
        };//经纬度以及地点
    };

    goSelClass(){
        if(this.state.address == '' || typeof(this.state.address) == undefined || this.state.address == undefined){
            Toast.info('请先选择可用地址！')
            return
        }
        var state = this.props.history.location.datas;
        let addressLocation = poi.lat + '_' + poi.lng;
        this.convertjwd(poi.lat,poi.lng,6,(r)=>{
            let params = {
                token: this.props.userInfo.token,
                "data": {
                    "addressLocation": r,
                    "stationId": this.props.location.stationId
                }
              };
            //   Toast.loading("正在加载",0);
            checkDistance(params).then((res) => {
              if (res.data.code === '1003') {
                Toast.info(res.data.msg);
              } else if(res.data.code === '0000'){
                    state.returnData({
                        type:state.type,
                        address:this.state.address,
                        point:poi,
                        startTime:this.props.location.startTime,
                        phone:this.props.location.phone,
                        shunt:this.props.location.shunt,
                        startCityPosition:this.props.location.startCityPosition,
                        endCityPosition:this.props.location.endCityPosition,
                        shuntType:this.props.location.shuntType
                    });//把确认好的经纬度传过去
    
                this.props.history.goBack();
              }
          })
        })
    //     let params = {
    //         token: this.props.userInfo.token,
    //         "data": {
    //             "addressLocation": addressLocation,
    //             "stationId": this.props.location.stationId
    //         }
    //       };
    //     //   Toast.loading("正在加载",0);
    //     checkDistance(params).then((res) => {
    //       if (res.data.code === '1003') {
    //         Toast.info(res.data.msg);
    //       } else if(res.data.code === '0000'){
    //             state.returnData({
    //                 type:state.type,
    //                 address:this.state.address,
    //                 point:poi,
    //                 startTime:this.props.location.startTime,
    //                 phone:this.props.location.phone,
    //                 shunt:this.props.location.shunt,
    //                 startCityPosition:this.props.location.startCityPosition,
    //                 endCityPosition:this.props.location.endCityPosition,
    //                 shuntType:this.props.location.shuntType
    //             });//把确认好的经纬度传过去

    //         this.props.history.goBack();
    //       }
    //   })
        
       
    }
    render(){
        const props = this.props.location.datas;
        const locationDatas = this.props.location;
        var addressStr = '';
        return(
            <div className="selAddress">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()} />}
                >{props.type == 'start' ? '上车地址' : '下车地址'}</NavBar>
                <div id="mapContainer"/>
                {
                    this.state.isError ? <div className="errTips"><span>{this.state.curTips}</span></div> : null
                }
                <img className="mapIcon" src={mapImg} alt=""/>
                <div className="topBar">
                {
                    locationDatas.startCity ? 
                        (<div className="selCity"><span style={{paddingRight: "10px"}}>{locationDatas.startCity}</span></div>) 
                        :
                        (<div className="selCity" onClick={this.toggleCity}><span>{this.state.endCity ? this.state.endCity :addressStr}</span></div>)
                }
                    <SearchBar
                        className="searchBar"
                        value={this.state.searchValue}
                        placeholder={props.type == 'start' ? '哪儿上车？' : '哪儿下车？'}
                        onChange={this.searchChange}
                        showCancelButton={false}
                        onCancel={this.onClear}
                        onClear={this.onClear}
                    />
                </div>
                <div className="bottom">
                   <div className="addressText">
                       <i className="icon iconfont icondaixiadanchufadi"/>
                       <div>{this.state.address ? this.state.address : '请拖动选址或者输入地址选址'}</div>
                   </div>
                    <button onClick={()=>this.goSelClass()}>{props.type == 'start' ? '确认上车点' : '确认下车点'}</button>
                </div>

                <div className="poiList" style={this.state.poiListFlag == false  ? {height:'0'} : {height:'100%'}} ref={dom => {this.tabDOM = dom}}>
                    <div>
                       {/*  <div className="history"><i className="icon iconfont iconlishi"/>历史记录</div>
                        <div className="historyText">
                            文山市七花广场同德街大胜酒店的发防晒霜的说法是
            </div> */}
                        <div className="mapSel" onClick={this.onClear}><i className="icon iconfont iconditushangxuandian"/>在地图上选点</div>
                    </div>

                    {
                        this.state.poiList.length > 0 ? (
                            <div className="list">
                                {
                                    this.state.poiList.map((res, i) => (
                                        <div className="item"  key={i}  onClick={() => this.selPoi(res)} >
                                            <i className="icon iconfont icondituliebiaotubiao"/>
                                            <div>
                                                <div>{res.title}</div>
                                                <span>{res.address}</span>
                                            </div>
                                        </div>

                                    ))
                                }
                            </div>
                        ): <div className='tishi'>请输入搜索内容</div>
                    }

                </div>
                    {
                        /* props.type == 'end'? (<div className="siteCity" style={this.state.siteCityFlag == false  ? {display:'none'} : {display:'block'}}>
                        <div className="curtCity">
                            <p>终点站城市：</p><span onClick={() => this.changeCity('end',addressStrLocation,addressLocation,addressLocationId,addressStr)}>{addressStr}</span>
                        </div>
                        <div className="hotCity">
                            <div className="title">中间起止点</div>
                            <div className="hotText">
                                {
                                    this.state.passStation.length > 0 ? this.state.passStation.map((res,i)=>(
                                        <span key={i} onClick={() => this.changeCity('pass',res.location,res)}>{res.city}</span>
                                    )):<div>该行程无中间起止点</div>
                                }
                            </div>
                        </div>
                    </div>) :null */
                    }
                
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/Home/changeRole/Shunt/SelectAddress/index.js